import { Reducer } from 'redux';

import { TopicOnboardingAction } from '../../domains/topicsFollowedOnboarding/actions.types';
import { Topic } from '../types';

import { TopicsFollowedOnboarding } from './types';

const followTopic = (state: TopicsFollowedOnboarding, topicId: Topic['id']) => {
  const topicIds = [...new Set([...state.topicIds, topicId])];
  const followTopicsCount = state.topicIds.length === topicIds.length ? state.topicsCount : state.topicsCount + 1;

  return { topicsCount: followTopicsCount, topicIds };
};

const unfollowTopic = (state: TopicsFollowedOnboarding, topicId: Topic['id']) => {
  const followedTopics = state.topicIds.filter((followTopicId) => followTopicId !== topicId);

  return {
    topicsCount: followedTopics.length,
    topicIds: followedTopics,
  };
};

const initialState: TopicsFollowedOnboarding = {
  topicsCount: 0,
  topicIds: [],
};

const reducer: Reducer<TopicsFollowedOnboarding, TopicOnboardingAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TOPIC.ONBOARDING_FOLLOW':
      return followTopic(state, action.payload.topicId);
    case 'TOPIC.ONBOARDING_UNFOLLOW':
      return unfollowTopic(state, action.payload.topicId);
    default:
      return state;
  }
};

export default reducer;
